<template>
  <v-dialog
    v-model="showLibrarioesVersionsDialog"
    :width="'30vw'"
    persistent
    :loading="cardLoading"
  >
    <v-card>
      <v-card-title>
        <v-row
          align="center"
          justify="space-between"
          class="flex-grow-1 flex-nowrap mt-2"
          style="overflow-x: auto; white-space: nowrap;"
        >
          <div class="d-flex align-center mr-2">
            <span class="text-h6 ml-2">Libraries</span>
          </div>

          <v-divider vertical class="mx-2" />

          <div class="d-flex align-center mr-2">
            <v-combobox
              v-model="parentLibrary"
              :rules="rules"
              auto-select-first
              dense
              hide-details
              :clearable="false"
              clear-icon=""
              solo
              :items="parentLibraries"
              item-text="category"
              label="Select Library"
              style="max-width: 180px;"
              class="custom-combobox"
            />
          </div>

          <v-divider vertical class="mx-2" />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                small
                dark
                text
                elevation="0"
                color="blue darken-2"
                v-bind="attrs"
                v-on="on"
                @click="onRestartClick"
              >
                <v-icon dark>mdi-restart</v-icon>
              </v-btn>
            </template>
            <span>Restart</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                small
                dark

                elevation="0"
                color="red darken-2"
                @click="onDeleteClick(currentParentLibrary)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                small
                dark
                elevation="0"
                color="blue-grey"
                @click="showAddLibraryDialog = true"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>

          <div >
              <v-btn
                class="mx-1"
                color="secondary"
                fab
                small
                dark
                elevation="0"
                @click="onEditLibrary"
                :disabled="!currentParentLibrary || !currentParentLibrary.id"
                :loading="loading"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
              <EditLibraries
                :show.sync="showEditDialog"
                :selectedLibrary="currentParentLibrary"
              />
            </div>

            <v-divider vertical class="mx-2" />

          <div class="d-flex align-center">
            <v-btn icon text elevation="0" @click="closeLibrariesVersionDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

        </v-row>

      </v-card-title>

      <div class="pt-4">
        <v-form lazy-validation v-model="valid" ref="librariesVersionForm">
          <!-- Data Table for Libraries -->
          <v-card-text>
            <div style="max-height: 250px; min-height: 250px; overflow-y: auto;">
              <v-data-table
                :headers="[
                  { text: 'Version', value: 'version' ,align:'start'},
                  { text: 'Actions', value: 'actions', align: 'end' }
                ]"
                :items="settingNames"
                class="elevation-1"
                dense
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn icon @click="updateVersion(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="deleteVersion(item)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-card-text>

          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>Edit</v-card-title>
              <v-card-text>
                <v-text-field v-model="editedItem.setting_name" label="Version" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="saveVersion">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-title class="py-1">Enter Version</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="version"
              class="py-1 inputChipset"
              hide-details="auto"
              clearable
              prepend-inner-icon="mdi-door"
              required
              :rules="rules"
              outlined
              label="Version"
              hint="Format: x.x.x"
            ></v-text-field>
          </v-card-text>

          <v-card-text class="justify-end d-flex">
            <v-btn
              color="primary"
              @click="saveData"
              :disabled="!valid || loading"
              :loading="loading"
            >
              add version
            </v-btn>
          </v-card-text>

          <add-library-view
            :show.sync="showAddLibraryDialog"
            :showUpdateOrEdit="false"
          />

        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
import AddLibraryView from './AddLibraryView.vue'
import EditLibraries from './EditLibraries.vue'
export default {
  components: {
    AddLibraryView,
    EditLibraries
  },
  data () {
    return {
      rules: [(v) => !!v || 'Field is required'],
      parentLibrary: '',
      editedItem: {},
      showEditDialog: false,
      dialog: false,
      showAddLibraryDialog: false,
      currentParentLibrary: {
        id: null,
        definition: null
      },
      version: null,
      loading: false,
      cardLoading: false,
      valid: true,
      parentLibraries: [],
      settingNames: [],
      actionButtons: [
        {
          icon: 'mdi-pencil-circle-outline',
          color: 'grey',
          func: this.updateVersion
        },
        {
          icon: 'mdi-delete-outline',
          color: 'red',
          func: this.deleteVersion,
          condition: {
            deleted: false
          }
        }
      ]

    }
  },
  computed: {
    parentLibraryDefinition () {
      return this.parentLibrary.definition
    }
  },
  mounted () {
    this.getParentLibraries()
  },

  props: {
    showLibrarioesVersionsDialog: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    parentLibrary (val) {
      if (val) {
        this.currentParentLibrary = {
          id: val.id,
          definition: val.definition
        }
        this.getSettingNames(val.category)
      } else {
        this.currentParentLibrary = {
          id: null,
          definition: null
        }
        this.settingNames = []
      }
    }
  },

  methods: {

    async fetchSettingName () {
      this.$store.dispatch('getSettingNameList')
    },
    onEditLibrary () {
      if (!this.currentParentLibrary || !this.currentParentLibrary.id) {
        Swal.fire('Warning!', 'Please select a library to edit.', 'warning')
        return
      }

      this.showEditDialog = true
    },
    async onDeleteClick (item) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to delete the parent and all its children. This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      })

      if (result.isConfirmed) {
        try {
          this.loading = true
          const response = await apiService.delete(`admin/delete-exp-parent/${item.id}`)

          if (response.data.ok) {
            Swal.fire('Deleted!', 'Parent and all children deleted successfully.', 'success')

            // Refresh the parent libraries list
            this.parentLibrary = ''
            this.currentParentLibrary = { id: null, definition: null }
            this.settingNames = []
            this.organizations = null

            await this.getParentLibraries()
          } else {
            Swal.fire('Error!', response.data.message, 'error')
          }
        } catch (error) {
          Swal.fire('Error!', error.response?.data?.message || 'Failed to delete parent and children.', 'error')
          console.error('Delete error:', error)
        } finally {
          this.loading = false
        }
      }
    },
    closeDialog () {
      this.dialog = false
      this.editedItem = {}
    },
    // Calls AddLibraryView dialog.
    updateVersion (item) {
      this.editedItem = {
        id: item.id,
        setting_name: item.setting_name || item.version // fallback
      }
      this.dialog = true
    },
    saveVersion () {
      if (!this.editedItem.id || !this.editedItem.setting_name) {
        console.error('ID veya setting_name eksik!')
        return
      }
      apiService
        .put('admin/update-setting-name', {
          id: this.editedItem.id,
          setting_name: this.editedItem.setting_name
        })
        .then((response) => {
          const newItem = response.data.data
          if (newItem) {
            this.settingNames.push(newItem)
          } else {
            this.getSettingNames(this.parentLibrary.category)
          }

          if (response.data.ok) {
            const index = this.settingNames.findIndex(i => i.id === this.editedItem.id)
            if (index !== -1) {
              this.settingNames[index].setting_name = this.editedItem.setting_name
            }

            Swal.fire('Updated!', 'Setting name successfully updated.', 'success')
            this.closeDialog()
          } else {
            Swal.fire('Error!', response.data.message, 'error')
            console.error('Server error', response.data.message)
          }
        })
        .catch((error) => {
          Swal.fire('Error!', error.response?.data?.message || error.message, 'error')
          console.error('Update error:', error)
        })
    },

    async deleteVersion (item) {
      try {
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'You wont be able to revert this!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel'
        })

        if (!result.isConfirmed) {
          return
        }

        const response = await apiService.delete('admin/delete-setting-name', {
          params: { id: item.id }
        })

        if (response.data.ok) {
          this.settingNames = this.settingNames.filter((setting) => setting.id !== item.id)
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
        } else {
          Swal.fire('Error!', response.data.message, 'error')
        }
      } catch (error) {
        Swal.fire('Error!', `Failed to delete setting: ${error.response?.data?.message || error.message}`, 'error')
        console.error('Delete error:', error)
      }
    },
    getParentLibraries () {
      this.cardLoading = true
      apiService
        .get('admin/get-parent-libraries-category')
        .then((res) => {
          // Getting parent libraries shown in combobox here.
          this.parentLibraries = res.data.data
        })
        .catch((err) => {
          console.log(err.response)
        })
        .finally(() => {
          this.cardLoading = false
        })
    },
    getSettingNames (category) {
      if (!category) return
      this.cardLoading = true
      apiService
        .get('admin/get-child-libraries-category', {
          params: {
            category: category
          }
        })
        .then((res) => {
          this.settingNames = res.data.data
        })
        .catch((err) => {
          console.log(err.response)
        })
        .finally(() => {
          this.cardLoading = false
        })
    },
    async onRestartClick () {
      try {
        this.cardLoading = true
        await this.getParentLibraries()
        Swal.fire('Success!', 'Parent libraries refreshed successfully.', 'success')
      } catch (error) {
        Swal.fire('Error!', 'Failed to refresh parent libraries.', 'error')
        console.error('Refresh error:', error)
      }
    },
    saveData: function () {
      if (this.$refs.librariesVersionForm.validate()) {
        this.loading = true
        const librariesVersionPayload = {
          parent_exp_docker_id: this.parentLibrary.id,
          setting_name: this.version
        }

        apiService
          .post('admin/add-exp-child', librariesVersionPayload)

          .then((response) => {
            const newItem = response.data.data
            if (newItem) {
              this.settingNames.push(newItem)
            } else {
              this.getSettingNames(this.parentLibrary.category)
            }

            const form = this.$refs.librariesVersionForm
            if (form) {
              this.version = null
              this.$refs.librariesVersionForm.resetValidation()
            }

            this.$store.dispatch('getDockers')
            Swal.fire('Success!', 'Version added.', 'success')
          })
          .catch((err) => {
            Swal.fire('Warning!', `${err.response.data.message}`, 'warning')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    updateParentExp () {
      if (!this.currentParentLibrary || !this.currentParentLibrary.id) {
        Swal.fire('Warning!', 'No parent library selected.', 'warning')
        return
      }

      this.loading = true

      const formData = new FormData()
      formData.append('id', this.currentParentLibrary.id)
      formData.append('name', this.currentParentLibrary.name || '')
      formData.append('definition', this.currentParentLibrary.description || '')
      formData.append('organizations', this.currentParentLibrary.organizations || '')
      formData.append('isPopular', this.currentParentLibrary.isPopular || false)

      if (this.currentParentLibrary.imageFile) {
        formData.append('file', this.currentParentLibrary.imageFile)
      }

      apiService
        .put('admin/update-parent-exp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          if (res.data.ok) {
            Swal.fire('Success!', 'Parent library updated successfully.', 'success')
            this.getParentLibraries() // Listeyi güncelle
          } else {
            throw new Error(res.data.message || 'Update failed')
          }
        })
        .catch((err) => {
          Swal.fire('Warning!', err.response?.data?.message || err.message, 'warning')
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeLibrariesVersionDialog () {
      this.$emit('close-libraries-version')
    }
  }
}
</script>

  <style>
.inputChipset input[type='number'] {
  -moz-appearance: textfield;
}

.inputChipset input::-webkit-outer-spin-button,
.inputChipset input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.custom-combobox .v-input__control {
  font-size: 20px;
}
.custom-combobox .v-list-item__title {
  font-size: 20px;
}
</style>
